import React, { FunctionComponent, useMemo } from 'react';
import { Text, Preset, ShadeColor } from '@lux/text';
import { Translate } from '@pegasus/translation';

import { OTHER_SIZES } from '@client/config/constants';

import { Wrapper, NoCategorySublinePlaceholder } from './styles';

interface Props {
    categorySubline: string[];
}

export const CategorySubline: FunctionComponent<Props> = ({ categorySubline }: Props) => {
    const orderedCategories = useMemo(
        () =>
            categorySubline?.reduceRight(
                (prev, cur) => (cur === OTHER_SIZES ? [...prev, cur] : [cur, ...prev]),
                [],
            ),
        [categorySubline],
    );
    if (
        !categorySubline ||
        categorySubline.length === 0 ||
        (categorySubline.length === 1 && categorySubline[0] === OTHER_SIZES)
    ) {
        return <NoCategorySublinePlaceholder />;
    }

    return (
        <Wrapper>
            {orderedCategories.map((category, index) => (
                <Text preset={Preset.S} color={ShadeColor.dark60} key={index}>
                    {index === 0 ? null : ', '}
                    <Translate message={`categorySubline.${category}`} raw />
                </Text>
            ))}
        </Wrapper>
    );
};

export default CategorySubline;
